<div class="amount-right-align">
  <div class="amount-text" data-cy="editPaymentTotalAmount">Total Amount</div>
  <div class="amount-big" data-cy="editPaymentTotalDollars">${{ total?.dollars }}</div>
  <div class="amount-small" data-cy="editPaymentTotalCents">.{{ total?.cents }}</div>
</div>
<div class="row">
  <div>
    <p class="float-right" data-cy="editPaymentDate">{{ date }}</p>
  </div>
</div>
